import { Component, Input, OnInit } from '@angular/core';
import {Observable, switchMap} from "rxjs";
import { NativeServiceApiProvider } from 'src/app/services/native-api-provider.service';
import {LogsService} from "../../../utils/services/logs.service";
import {BookListEntry} from '../../model/v3/drm';

@Component({
    selector: 'book-list-item',
    templateUrl: './book-list-item.component.html',
    styleUrls: ['./book-list-item.component.scss'],
    standalone: false
})
export class BookListItemComponent implements OnInit {
  private _entry: BookListEntry;

  @Input()
  set entry(entry: BookListEntry) {
    this._entry = entry;
    if (!entry) return;
    this.isContentLoading = false;
    this.logService.log(`showing book ${entry.share.product.id}`)
    this.reloadCover();
  }
  get entry() {
    return this._entry;
  }

  isImgLoading = true
  isContentLoading = true
  ebookCover = null

  constructor(
    private apiProvider: NativeServiceApiProvider,
    private logService: LogsService) {}

  ngOnInit(): void {

  }

  private reloadCover() {
    if (!this.entry) return;
    const productId = this.entry.share.product.id
    this.logService.log(`asking for book ${productId} cover`)
    this.isImgLoading = true;
    this.loadCover(productId).subscribe( data => {
      this.logService.log(`got book ${productId} cover: ${data}`)
      this.ebookCover = data;
      this.isImgLoading = false;
    });
  }

  private loadCover(productId: number): Observable<string> {
    return this.apiProvider.booksV3().pipe(
      switchMap( api => api.getImageUrl(productId, this.entry.releaseId))
    )
  }

  getEbookName() {
    return this.entry?.share.product.name
  }

  getLanguage() {
    return this.entry && this.entry.share.product.categories && this.entry.share.product.categories[0]
  }

  getEbookId() {
    return this.entry?.share.product.id
  }

  getImage() {
    return this.ebookCover
  }


  getEbookStateClass() {
    if(this.entry?.downloaded)
      return 'ebook-downloaded'

    if(!this.entry?.downloaded &&
      this.entry?.share.emptySlots === 0)
      return 'ebook-not-downloaded'

    return '';
  }
}
